import { toaster } from "@/components/ui/toaster";

const useCustomToast = () => {
  const showSuccessToast = (description: string) => {
    toaster.create({
      title: "¡Satisfactorio!",
      description,
      type: "success",
    });
  };

  const showErrorToast = (description: string) => {
    toaster.create({
      title: "¡Error!",
      description,
      type: "error",
    });
  };

  return { showSuccessToast, showErrorToast };
};

export default useCustomToast;
